/* eslint-disable no-undef */
import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import LineTableMonth from '../../../../components/NovoSistema/LineTableMonth';
import TableMonth from '../../../../components/NovoSistema/TableMonth';
import WrapperButtonsLinks from '../../../../components/NovoSistema/WrapperButtonsLinks';

export default function TemplateApuracaoTributaria() {
  const [year, setYear] = useState('21');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Apuração tributária" linkIcon="/images/icons/moneyPaper.svg" />
        <WrapperButtonsLinks year={year} setYear={setYear} />
        <TableMonth>
          <LineTableMonth
            title="IPTU – Imposto Predial e Territorial Urbano"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="ISS – Imposto Sobre Serviços"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="ICMS – Imposto sobre Circulação de Mercadoria e Serviços"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="PIS – Programa de Integração Social"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="COFINS - Contribuição Social para o Financiamento da Seguridade Social"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="CSLL – Contribuição Social Sobre o Lucro Líquido"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="IRPJ – Imposto de Renda da Pessoal Jurídica"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="PCC – Pis/Cofins/Contribuição Social - Retenção"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="IRRF – Imposto de Renda Retido na Fonte"
            firstLetter="G"
            secondLetter="P"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
        </TableMonth>
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
